var map = {
	"./abyrg-framtid.json": 783,
	"./atvinnumal.json": 784,
	"./byggdarmal.json": 785,
	"./candidates2.json": 786,
	"./categories.json": 682,
	"./evropumal.json": 787,
	"./flokkur-folksins.json": 788,
	"./framsoknarflokkurinn.json": 789,
	"./frjalslyndi-lydraedisflokkurinn.json": 790,
	"./heilbrigdismal.json": 791,
	"./husnaedismal.json": 792,
	"./jafnrettismal.json": 793,
	"./loftslagsmal.json": 794,
	"./menntamal.json": 795,
	"./midflokkurinn.json": 796,
	"./parties.json": 658,
	"./piratar.json": 797,
	"./replies-candidates2.json": 675,
	"./replies-parties.json": 706,
	"./samfylkingin.json": 798,
	"./samgongumal.json": 799,
	"./sjalfstaedisflokkurinn.json": 800,
	"./sjavarutvegsmal.json": 801,
	"./skattamal.json": 802,
	"./sosialistaflokkurinn.json": 803,
	"./sottvarnarmal.json": 804,
	"./stjornarskrarmal.json": 805,
	"./umhverfismal.json": 806,
	"./utlendingamal.json": 807,
	"./velferdarmal.json": 808,
	"./vidreisn.json": 809,
	"./vinstri-graen.json": 810
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 782;


//////////////////
// WEBPACK FOOTER
// ./data/build ^\.\/.*\.json$
// module id = 782
// module chunks = 5 6